import React from "react";
import { PlanToken } from "../../atoms/PlanToken";
import { Sentence } from "./PlanSentence.styles";
import type { PlanSentenceProps } from "./PlanSentence.types";

/** A sentence made of plain text and editable token buttons. Add a space inside the text segments around tokens. */
export const PlanSentence: React.FC<PlanSentenceProps> = ({ segments, ariaLabel, className }) => (
  <Sentence className={className} aria-label={ariaLabel}>
    {segments.map((s, i) =>
      s.kind === "text" ? (
        <React.Fragment key={i}>{s.text}</React.Fragment>
      ) : (
        <PlanToken key={i} label={s.label} onClick={s.onClick} tone={s.tone} ariaLabel={s.ariaLabel} />
      ),
    )}
  </Sentence>
);

export default PlanSentence;
